import React from 'react'
import { SearchInput } from 'components'
import { DateTimeHandler } from 'utils'
import { debounce as _debounce, size as _size } from 'lodash'


const ARR_INFO_KEY = [ 'ua80010_cp', 'ua80021_cp', 'ua80208_cp' ];
const INFO_MAPPING = {
	price : 'ua80010_cp',
	rise	: 'ua80021_cp',
	date	: 'ua80208_cp',
	limit : 'ua80211_cp',
};
const INFO_MAPPING_REVERSE = {
	ua80010_cp : 'price',
	ua80021_cp : 'rise',
	ua80208_cp : 'date',
	ua80211_cp : 'limit',
};

// star-shape btn tp add /remove a stock to / from my-fav
export class StockSelector extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = { is_enabled: true };
	}

	onClick = (e) => {
		const {
				stock,
				current_group,
				fav,
				is_fav,
				onFavGroupStockerAdd,
				onFavGroupStockDelete,
				onModalOpen,
			} = this.props;

		if (fav.length >= 50) {
			onModalOpen('stock-add-warning');

			return;
		}

		const params = { group_id: current_group + 1, stock_code: stock.stock_code };

		this.setState(
			{ is_enabled: false },
			() => {
				if (!is_fav) {
					onFavGroupStockerAdd(params);
				} else {
					onFavGroupStockDelete(params);
				}
			}
		);
	}

	stockSubmitHandler = (selectStock) => {
		const { onStockSet, onStockRecordRequest } = this.props;

		onStockSet(selectStock);
		onStockRecordRequest(selectStock.stock_code);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.is_fav !== this.props.is_fav) {
			this.setState({ is_enabled: true });
    }
	}

	render() {
		const isEnabled = this.state.is_enabled;
		const {
			is_fav,
			stock,
			favoriteBtn,
			hideStock,
			isTaiwanOnly,
			is_mobile,
		} = this.props;
		const info = stock.info ? stock.info.data : null;
		const onClick = isEnabled
			?
			_debounce(this.onClick, 300, { leading: true, trailing: false })
			:
			null;

		let InfoComponent = null;

		if (info && _size(info) > 0) {
			// rise
			const rise = info[INFO_MAPPING.rise];
			// limit
			const limit = info[INFO_MAPPING.limit];

			let colour = 'grey';

			if (rise.Data > 0) {
				colour = 'red';
			} else if (rise.Data < 0) {
				colour = 'green';
			}

			InfoComponent = (
				<div className='stock-info'>
					{ARR_INFO_KEY.map((key) => {
						const { Data, UnitRef } = info[key];

						switch (INFO_MAPPING_REVERSE[key]) {
							case 'price':
								const unit = UnitRef.replace('(', '').replace(')', '');

								return (
									<span className={`margin-left-8 txt-${colour}`} key={key}>
										{Data}{is_mobile ? ` ${unit}` : ''}
									</span>
								);

							case 'rise':
								const isLimitReached = limit.Data;

								return ((Data === null || Data === 'NaN' || Data === '')
									?
									null
									:
									<span
										className={`margin-left-8 ${(isLimitReached > 0)
											?
											`padding-bottom-2 padding-horizontal-5 bg-${colour}`
											:
											''}`}
										key={key}
									>
										<span className={`txt-${(isLimitReached > 0)
												? 'white' : colour}`}>
											{`${(Data > 0) ? '+' : ''}${Data}%`}
										</span>
									</span>
								);

							case 'date':
								const date = DateTimeHandler.getDate(Data).substring(5);

								return (!date || is_mobile)
									?
									null
									:
									<small
										className='margin-left-8 txt-grey'
										key={key}
									>
										{date} 收盤價
									</small>;

							default: return null;
						}
					})}
				</div>
			);
		}

		return (
			<div className='stock-container'>
				{favoriteBtn && (// dashboard-toolbar
					<div className='my-fav-box margin-horizontal-5'>
						<div
							className={`my-fav my-fav-${is_fav ? 'remove' : 'add'}`}
							title={is_fav ? '從我的最愛移除' : '加入我的最愛'}
							onClick={onClick}
						>
							<i className={`add txt-orange
									elegant elegant-eleganticons-14${is_fav ? '5' : '3'}`} />
						</div>
					</div>
				)}

				{!hideStock && (// not data-table
					<>
						<div className='stock'>
							{/* stock */}
							<div className='stock-title'>{stock.stock_name}</div>

							<div className='stock-number margin-left-5'>{stock.stock_code}</div>

							{/* stock info */}
							{InfoComponent}
						</div>

						{/* search input */}
						<SearchInput
							customClassName=''
							type='stock-container'
							searchType='stock'
							isTaiwanOnly={isTaiwanOnly}
							callback={this.stockSubmitHandler}
						/>
					</>
				)}
			</div>
		);
	}
}
